import React from 'react'
import { Type } from 'lucide-react'
import ContentRenderer from '../../../components/ContentRenderer'
import { cardToContentItems } from '../lib/cardToContentItem'
import { genId } from '../lib/id'
import type { TextCard } from '../types/LessonDoc'
import type { CardDef, CardEditorProps, CardPreviewProps } from './types'

const Editor: React.FC<CardEditorProps> = ({ card, onChange }) => {
  const c = card as TextCard
  return (
    <div className="space-y-2">
      <label className="text-xs font-bold text-gray-500 uppercase">Nội dung (hỗ trợ **đậm**, $công thức$)</label>
      <textarea
        className="w-full min-h-[140px] p-3 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-200 outline-none"
        value={c.content}
        onChange={(e) => onChange({ content: e.target.value })}
        placeholder="Nhập nội dung lý thuyết. Dùng $E = mc^2$ cho công thức inline, $$...$$ cho công thức khối."
      />
    </div>
  )
}

const Preview: React.FC<CardPreviewProps> = ({ card }) => {
  const items = cardToContentItems(card)
  return items ? <ContentRenderer content={items} /> : null
}

export const textCardDef: CardDef = {
  type: 'text',
  label: 'Văn bản',
  description: 'Đoạn lý thuyết có công thức KaTeX',
  icon: Type,
  color: 'bg-slate-50 text-slate-600',
  createDefault: (): TextCard => ({ id: genId(), type: 'text', content: '' }),
  Editor,
  Preview,
}
